<template>
  <v-card v-if="summary" outlined class="mb-4" color="primary">
    <v-card-title class="white--text font-weight-bold pt-3 pb-1 px-4">
      {{ $t('routines.execution.score_summary') }}
    </v-card-title>

    <v-card-text class="px-6 py-3">
      <div class="d-flex align-center flex-wrap" style="gap: 32px">
        <span
          class="font-weight-bold white--text"
          style="font-size: 44px !important"
        >
          {{ formattedScorePercentage }}
        </span>

        <span class="font-weight-bold white--text mt-2">
          <span class="mt-1" style="font-size: 28px"
            >{{ formattedTotalPoints }}
          </span>
          <span style="text-transform: lowercase">{{
            $t('routines.execution.total_points', {
              count: summary.totalPoints,
            })
          }}</span>
        </span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatLocalizedPoints } from '@/lib/formatLocalizedPoints'
import { formatScorePercentage } from '@/lib/formatScorePercentage'

export default {
  name: 'SummaryScoreCard',

  props: {
    summary: {
      type: Object,
      default: null,
    },
  },

  computed: {
    formattedTotalPoints() {
      return formatLocalizedPoints(this.summary?.totalPoints ?? 0)
    },

    formattedScorePercentage() {
      return formatScorePercentage(this.summary?.scorePercentage, {
        translate: (...args) => this.$t(...args),
      })
    },
  },
}
</script>
